import styled from '@emotion/styled'
import { theme, themeUtils } from 'styles/theme'

export const ElevatedContainer = styled.div`
  position: relative;
  width: 100%;
`

export const PostalAddressSuggestionsBox = styled.div`
  cursor: pointer;
  z-index: 1;
  background-color: ${theme.palette.surface.default};
  position: absolute;
  border: 1px solid ${theme.palette.surface.secondary};
  border-top: none;
  border-radius: 4px;
  box-shadow: 0px 4px 3px ${theme.palette.surface.tertiary},
    4px 0px 3px ${theme.palette.surface.tertiary},
    -2px 0px 2px ${theme.palette.surface.tertiary};
  box-sizing: border-box;
  width: 100%;
`

export const PostalAddressSuggestion = styled.p`
  padding: 5px 10px;
  display: flex;
  align-items: center;
  vertical-align: middle;
  position: relative;
  width: 100%;
  :hover {
    background-color: ${theme.palette.surface.secondary};
  }
  ${themeUtils.bodyXSmall}
`
